import { Subject } from '../observable/subject';
import { ObserverLike } from '../observable/observer';

export class ObservableMap<K, V> extends Map<K, V> {
  #subject = new Subject<Map<K, V>>();

  set = (key: K, value: V): this => {
    super.set(key, value);
    this.#subject.next(this);
    return this;
  };

  delete = (key: K): boolean => {
    const result = super.delete(key);
    this.#subject.next(this);
    return result;
  };

  clear = (): void => {
    super.clear();
    this.#subject.next(this);
  };

  subscribe = (observer: ObserverLike<Map<K, V>>): (() => void) => {
    const subscription = this.#subject.subscribe(observer);
    return () => subscription.unsubscribe();
  };
}
